export enum Interests {
  AnimalPolitico = 'Animal Político',
  ElSabueso = 'El Sabueso',
  AnimalGourmet = 'Animal Gourmet',
  AnimalMX = 'Animal MX',
  Newsweek = 'Newsweek',
}
